export default class GetOrganizationByIdError extends Error {

}
